module.exports = __webpack_public_path__ + "img/notificationBell.49be8709.svg";